export default import.meta.ROLLDOWN_FILE_URL_DBQrZBU$xvk9KsOre6JCwA